import { fetchEstateDetails } from '@portals/core-immobilien/src/api';
import { Page } from '@portals/root/models';
import { mapEstateDetailApiResponse } from '@portals/sip-client-data/src/general/ApiClientMapping/ApiClientMapping';
import { EstateDetail as EstateDetailType } from '@portals/sip-client-data/src/general/ApiClientTypes';
import { endsWith, get, replace } from 'lodash-es';
import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import { EstateDetailsWithHeaderFooter } from '../../src/components/EstateDetails/EstateDetailsWithHeaderFooter';
import { SeoHeader } from '../../src/components/EstateDetails/SeoHeader/SeoHeader';
import { setHeadersAttachToBaseProps } from '../../src/utils/myraHeaders';
import { getHeaderFooterPageProps } from '../../src/utils/strapiUtils';

interface Props {
  estate: EstateDetailType;
  pageProps: Page;
}

export default function EstateDetailPage({ estate, pageProps }: Props): React.ReactElement {
  return (
    <>
      <SeoHeader seo={estate.seo} id={estate.id} />
      <EstateDetailsWithHeaderFooter estate={estate} pageProps={pageProps} />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async function getServerSideProps({ params, res, req, preview }) {
  const idWithHtmlSuffix = get(params, 'id', undefined);
  if (!endsWith(idWithHtmlSuffix, '.html')) {
    return {
      redirect: {
        permanent: true,
        destination: `/expose/${idWithHtmlSuffix}.html`,
      },
    };
  }
  const id = replace(idWithHtmlSuffix, '.html', '');
  const estateResponse = await fetchEstateDetails(id);
  if (!estateResponse || estateResponse.id === null) {
    return {
      redirect: {
        permanent: false,
        destination: `/expose/not_found`,
      },
    };
  }
  const baseProps = { props: {} };
  setHeadersAttachToBaseProps(res, req, baseProps, preview);

  const estateData = mapEstateDetailApiResponse(estateResponse);
  return {
    props: {
      estate: estateData,
      ...(await serverSideTranslations('de', ['common'])),
      pageProps: await getHeaderFooterPageProps('expose.html'),
    },
  };
};
